import { createApp } from 'vue'
import App from './App.vue'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { loadFonts } from './plugins/webfontloader'
import VueConfetti from 'vue-confetti';
import { createManager } from '@vue-youtube/core';
import '@mdi/font/css/materialdesignicons.css';


loadFonts()

const vuetify = createVuetify({
  components,
  directives
})

createApp(App)
  .use(vuetify)
  .use(VueConfetti)
  .use(createManager())
  .mount('#app')


